import React, { useState } from 'react'
import Style from './connectorCard.module.css'

const initials = (name) => (name || '?')
    .replace(/[^A-Za-z0-9& ]/g, '')
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()

const ConnectorLogo = ({ src, name, size = 'md' }) => {
    const [failed, setFailed] = useState(false)
    return (
        <span className={[Style.logo, Style[`logo_${size}`]].join(' ')} aria-hidden="true">
            {src && !failed
                ? <img src={src} alt="" onError={() => setFailed(true)} />
                : <span className={Style.logoInitials}>{initials(name)}</span>}
        </span>
    )
}

export default ConnectorLogo
